package navigation.settings.datetime

import androidx.compose.foundation.layout.*
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.koin.koinScreenModel
import com.essntl.uikit.components.dropdown.EsInputDropdownMenu
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.dateformat.domain.DateFormat
import core.dateformat.ui.DateTimeEvent
import navigation.utils.NavLinkScreen

class DateTimeScreenNav(
    private val onRefresh: (() -> Unit) -> Unit,
) : NavLinkScreen {
    override val defaultTitle: String get() = "Date & Time"

    @Composable
    override fun Content() {
        val dateTimeScreenModel = koinScreenModel<DateTimeScreenModel>()
        val dateTimeState by dateTimeScreenModel.state.collectAsState()

        LaunchedEffect(Unit) {
            dateTimeScreenModel.onEvent(DateTimeEvent.GetInitialDateFormat)
            onRefresh {
                dateTimeScreenModel.onEvent(DateTimeEvent.GetInitialDateFormat)
            }
        }

        Column(
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.Start,
            modifier = Modifier
                .fillMaxWidth(0.5f)
                .padding(2.5f.spacing),
        ) {
            Text(
                text = "Date Format",
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.h4SemiBold20,
            )

            Spacer(modifier = Modifier.height(5.spacing))

            EsInputDropdownMenu(
                items = DateFormat.entries.map { it.format },
                selectedItem = dateTimeState.selectedDateFormat,
                text = { it },
                onItemSelected = {
                    dateTimeScreenModel.onEvent(DateTimeEvent.ChangeDateFormat(it))
                },
                label = "Choose your preferred date format",
                placeholder = "Enter Date Format",
                modifier = Modifier.offset(
                    x = 0.dp,
                    y = (-20).dp,
                ),
            )

            Text(
                text = "The selected format will be applied to all date fields in the app. Visible only to you.",
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.p1Medium16,
            )
        }
    }
}